import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

// Excel benzeri hücre: tıkla → düzenle; Enter/Tab/blur → kaydet; Esc → vazgeç
export function EditableCell({ value, onCommit, type = "text", align = "left", format, className = "", testid, placeholder = "—", disabled = false, title, autoEdit = false, wrap = false }) {
  const [editing, setEditing] = useState(autoEdit);
  const [draft, setDraft] = useState(value ?? "");
  const ref = useRef(null);
  useEffect(() => { if (!editing) setDraft(value ?? ""); }, [value, editing]);
  useEffect(() => { if (editing) { const t = setTimeout(() => { ref.current?.focus(); ref.current?.select?.(); }, 30); return () => clearTimeout(t); } }, [editing]);

  const commit = () => {
    setEditing(false);
    const next = type === "number" ? Number(String(draft).replace(",", ".")) : String(draft);
    const prev = type === "number" ? Number(value || 0) : String(value ?? "");
    if (type === "number" ? (Number.isNaN(next) || next === prev) : next === prev) return;
    onCommit(next);
  };
  const shown = format ? format(value) : (value === "" || value == null ? "" : String(value));

  if (editing && !disabled) {
    return (
      <input ref={ref} type={type === "number" ? "number" : "text"} step="any" value={draft}
        onChange={(e) => setDraft(e.target.value)} onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } else if (e.key === "Escape") { setEditing(false); setDraft(value ?? ""); } }}
        className={cn("w-full h-8 px-2 rounded-md border border-primary bg-white text-sm outline-none ring-2 ring-primary/20 tabular-nums", align === "right" && "text-right", className)}
        data-testid={testid ? `${testid}-input` : undefined} />
    );
  }
  return (
    <button type="button" disabled={disabled} onClick={() => setEditing(true)} title={title || (disabled ? undefined : "Düzenlemek için tıklayın")}
      className={cn("w-full min-h-8 px-2 py-1 text-left text-sm rounded-md border border-transparent hover:border-slate-300 hover:bg-white/70 transition-colors tabular-nums",
        wrap ? "whitespace-normal break-words leading-snug" : "truncate",
        align === "right" && "text-right", !shown && "text-muted-foreground/60 italic", disabled && "cursor-default hover:border-transparent hover:bg-transparent", className)}
      data-testid={testid}>
      {shown || placeholder}
    </button>
  );
}

// Hafif yerel açılır liste: defterde yüzlerce satırda her satıra ağır bileşen bağlanmaz (kasma önlenir)
export function SelectCell({ value, options, onCommit, testid, className = "" }) {
  return (
    <select value={value} onChange={(e) => e.target.value !== value && onCommit(e.target.value)} data-testid={testid}
      className={cn("h-8 w-full text-xs rounded-md border border-transparent bg-transparent hover:border-slate-300 hover:bg-white/70 px-1.5 cursor-pointer outline-none focus:border-primary", className)}>
      {options.map((u) => <option key={u} value={u}>{u}</option>)}
    </select>
  );
}
